import { useNavigate } from 'react-router-dom';

import Badge from '~/components/Badge';
import HeaderLogo from '~/components/HeaderLogo';
import LangSwitcher from '../LangSwitcher';
import { layoutStore } from "~/stores/layout";
import { getLink } from '~/providers/route';
import { ITemplateUser } from '~/interfaces';

import "./style.less";

export default function TopMenu({
	checkInternalRole = "none",
}: Pick<ITemplateUser, "checkInternalRole">) {
	const { smallLayout, showLeftMenu, setShowLeftMenu } = layoutStore(layoutState => ({
		smallLayout: layoutState.layout.smallLayout,
		showLeftMenu: layoutState.layout.showLeftMenu,
		setShowLeftMenu: layoutState.setShowLeftMenu,
	}));
	const navigate = useNavigate();

	function headerClick() {
		setShowLeftMenu(!showLeftMenu);
	}

	function logoClick() {
		if (checkInternalRole === "none") {
			navigate(getLink("projects"));
		} else {
			navigate(getLink("admin-projects"));
		}
	}

	return <div className="topMenu">
		<div className="topMenu_leftPart">
			{ smallLayout && !showLeftMenu && <HeaderLogo onClick={headerClick} onLogoClick={logoClick} /> }
		</div>
		<div className="topMenu_rightPart">
			<LangSwitcher />
			<Badge />
		</div>
	</div>;
}
